import * as React from "react";
import { FastField } from "formik";
import { posNumberonChange } from "./utils";
import { FormGroup } from "@lib/components";
import { Input } from "@lib/components";
import { Button } from "@lib/components";
import { ButtonGroup } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { Switch } from "@lib/components";
import { TabSelect } from "@lib/components";
import { inject, observer } from "mobx-react";
import { Modal } from "@lib/components";
import { ModalContent } from "@lib/components";
import { FormTreeSelect } from "@lib/components";
import { cloneDeepSafe, RestaurantUtils } from "@lib/common";
import { MobxComponent } from "../../../../../mobx/components";
import { RestaurantForm } from "../../../../../mobx/components/restaurant-form";
import { FieldOptionSetOptions } from "../menus/components/FieldOptionSetOptions";
import { TabGroup, TabItem } from "../settings-v2/receipt-printing";
import { EligibleItemsContainer, SettingsActionButtonContainer, SettingsActionButtonWrapper, SettingsFormGroup, SettingsFormGroupInput, SettingsFormInputContainer, SettingsFormLabelContainer, SettingsFormLabelLeftContainer, SettingsFormLabelRightContainer, SettingsSwitchContainer } from "../settings-v2";
import { IconHelp } from "../../../../components/v2/icons";
import { runOnceNotification } from "../../../../utils/run_once_notification";
import { UI } from "../../../../../core/ui";
import { isObject } from "lodash";
import { toJS } from "mobx";
import { MenuPresence } from "../../../../components/menu-presence";

type FormValues = T.Schema.Restaurant.Menu.RestaurantOptionSet | T.Schema.Restaurant.Menu.RestaurantModifier;

interface Props {
	type: "edit" | "create";
	initialValues: FormValues | null;
	close: () => void;
}

interface State {
	tab: string;
	add_to: string[];
	restaurantStock: T.Schema.RestaurantMenuStock.Schema;
	using_points: boolean;
}


/** The id of whatever this editor has open, in either menu schema. */
function presenceEntityId(initialValues: any): string | undefined {
	return initialValues?.id || initialValues?._id || undefined;
}

function MenuPresenceBar(props: { entityId?: string }) {
	return (
		<div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 4px 8px' }}>
			<MenuPresence scope="current-menu" entityId={props.entityId} />
		</div>
	);
}

@inject("store") @observer
export class RestaurantFormOptionSetV2 extends MobxComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			tab: "0",
			add_to: [],
			restaurantStock: cloneDeepSafe(this.injected.store.restaurant_stock!),
			using_points: false,
		};
	}

	setTab = (tab: string) => {
		this.setState({ tab });
	};

	setRestaurantStock = (restaurantStock: T.Schema.RestaurantMenuStock.Schema) => {
		this.setState({ restaurantStock });
	};

	dishes_in = (id: string) => {
		const r = this.injected.store.restaurant!;
		return RestaurantUtils.menu
			.filterDishes(r, (dish) => {
				// console.log(dish.name)
				// console.log(dish.type)
				// console.log(dish.option_sets)
				return dish.type !== "combo" && dish.option_sets.indexOf(id) !== -1;
			})
			.map((dish) => dish._id);
	};
  componentDidMount() {
    const presenceInitial = this.props.initialValues as { id?: string; _id?: string; name?: string } | null;
    const presenceId = presenceInitial?.id || presenceInitial?._id;
    if (presenceId) {
      this.injected.store.notifications.menuPresenceSetEntity('modifier', presenceId, presenceInitial?.name || null);
    }

    if (this.injected.store.isNewMenuSchema) {
      const restaurant = this.injected.store.restaurant!;
      const items = (restaurant.menus_v2 || []).flatMap((m: any) => m.items || []);
      // @ts-ignore
      const add_to = items.filter((i: any) => (i.modifiers || []).indexOf(this.props.initialValues.id) !== -1).map((i: any) => i.id);
      this.setState({
        add_to:  add_to || [],
      });
    }
  }


	componentWillUnmount() {
		this.injected.store.notifications.menuPresenceClearEntity();
	}

	componentDidUpdate(prevProps: Props) {
		const prevPresenceId = presenceEntityId(prevProps.initialValues);
		const nextPresenceId = presenceEntityId(this.props.initialValues);
		if (prevPresenceId !== nextPresenceId) {
			if (nextPresenceId) {
				this.injected.store.notifications.menuPresenceSetEntity(
					'modifier', nextPresenceId, (this.props.initialValues as any)?.name || null);
			} else {
				this.injected.store.notifications.menuPresenceClearEntity();
			}
		}

		if (this.props.initialValues && !prevProps.initialValues) {
			this.setTab("0");
			this.setState({
				//@ts-ignore
				add_to: this.dishes_in(this.props.initialValues._id),
				restaurantStock: cloneDeepSafe(this.injected.store.restaurant_stock!),
				//@ts-ignore
				using_points: this.props.initialValues.using_points === true,
			});
		}
	}

	render() {

		const { store } = this.injected;
		const { type, initialValues, close } = this.props;
		const { tab, add_to, using_points } = this.state;
		const restaurant = this.injected.store.restaurant!;

		return (
			<div style={{ width: '100%' }}>
				<TabGroup className='menus'>
					<TabItem
						active={this.state.tab === '0'}
						onClick={() => this.setState({ tab: '0' })}

					>
						General
					</TabItem>
					<TabItem
						active={this.state.tab === '1'}
						onClick={() => this.setState({ tab: '1' })}

					>
						Option Sets
					</TabItem>
					<TabItem
						active={this.state.tab === '2'}
						onClick={() => this.setState({ tab: '2' })}

					>
						Conditions
					</TabItem>
					<TabItem
						active={this.state.tab === '3'}
						onClick={() => this.setState({ tab: '3' })}
						className="long-text"
					>
						Add / Remove from Items
					</TabItem>
				</TabGroup>
				<RestaurantForm<FormValues>
					submit={async (r, values) => {

						let oldOptionSet = null;
						//@ts-ignore
						const existing = r.option_sets.findIndex((p) => p._id === values._id);

						// force set multiselect = true when using_points
						//@ts-ignore
						if (values.using_points === true) {
							values.conditions.multi_select = true;
						}

						if (existing === -1) {
							//@ts-ignore
							r.option_sets.push(values);
						} else {
							oldOptionSet = cloneDeepSafe(r.option_sets[existing]);
							//@ts-ignore
							r.option_sets[existing] = values;
						}

						for (const [i, m] of r.menus.entries()) {
							for (const [k, c] of m.categories.entries()) {
								for (const [z, d] of c.dishes.entries()) {
									if (add_to.indexOf(d._id) === -1) {
										//@ts-ignore
										const index = d.option_sets.indexOf(values._id);
										if (index !== -1) {
											r.menus[i].categories[k].dishes[z].option_sets.splice(index, 1);
										}
									} else {
										//@ts-ignore
										const index = d.option_sets.indexOf(values._id);
										if (index === -1) {
											//@ts-ignore
											r.menus[i].categories[k].dishes[z].option_sets.push(values._id);
										}
									}
								}
							}
						}

						const update = {
							$set: {
								menus: r.menus,
								option_sets: r.option_sets,
							},
						};
						//console.log(`SUBMIT: ${JSON.stringify(update)}`);

						// Update stock silently
						const updateStockItems = [];

						if (oldOptionSet) {
							for (const o of oldOptionSet.options || []) {
								//@ts-ignore
								const hasBeenDeleted = !values.options.find((v) => v._id === o._id);
								if (hasBeenDeleted) {
									updateStockItems.push({
										_id: o._id,
										key: "option_set_options" as "option_set_options",
										value: "" as "",
									});
								}
							}
						}

						for (const o of values.options || []) {
							updateStockItems.push({
								//@ts-ignore
								_id: o._id,
								key: "option_set_options" as "option_set_options",
								value: (() => {
									//@ts-ignore
									const val = this.state.restaurantStock.option_set_options[o._id];
									return typeof val === "undefined" ? "" as "" : val;
								})(),
							});
						}

						if (updateStockItems.length > 0) {
							store.api.menu_stock_update({
								_id: store.restaurant!._id,
								items: updateStockItems,
							})
								.then((result) => {
									store.setRestaurantStock(result.stock);
								})
								.catch(console.log);
						}

						return { r, update };

					}}
					customSubmit={store.isNewMenuSchema ?
						async (values, _form) => {
							const optionSetsV2 = restaurant.option_sets_v2 || [];
							//@ts-ignore
							const existing = optionSetsV2.findIndex((p) => p.id === values.id);
							let createdModifierId: string | undefined;
							const defaultPointValue = {
								whole: { points: 0, single: 0, double: 0 },
								half: { points: 0, single: 0, double: 0 },
							};
              let optionsToUpdate: any[] = [];
              if (values.options && values.options.length > 0) {
                optionsToUpdate = (values.options || []).map((option: any, optionIndex: number) => {
					//@ts-ignore
                  const priceType = values.type === "standard" ? "standard" :
                    option.variable_price_ref ? "variable" : "point";
                  let optionValue: any;
                  if (priceType === "standard") {
                    const standardRawPrice =
                      option.price?.value ??
                      option.price?.standardValue ??
                      option.price ??
                      0;
                    optionValue = Number(standardRawPrice);
                    if (Number.isNaN(optionValue)) optionValue = 0;
                  } else if (priceType === "variable") {
                    optionValue =
                      option.price?.value ?? option.price?.variableValue ?? 0;
                  } else {
                    const pointPriceFromRoot =
                      typeof option.price === "object" &&
                      option.price !== null &&
                      "whole" in option.price &&
                      "half" in option.price
                        ? option.price
                        : undefined;
                    optionValue =
                      pointPriceFromRoot ??
                      option.price?.value ??
                      option.price?.pointValue;
                    const hasValidPointStructure = optionValue && typeof optionValue === "object" &&
                      optionValue.whole && optionValue.half &&
                      typeof optionValue.whole.points === "number" && typeof optionValue.half.points === "number";
                    if (!hasValidPointStructure) {
                      optionValue = defaultPointValue;
                    }
                  }
                  return {
                    ...option,
                    price: {
                      type: priceType,
                      value: optionValue,
                    }
                  }
                });
              }

							try {
								if (existing === -1) {
                  const createModifierRes = await store.api.menu_create_modifier({
                    restaurant_id: restaurant._id,
                    data: {
                      ...values,
                      ...(optionsToUpdate.length > 0 ? { options: optionsToUpdate } : {})
                    }
                  })
                  createdModifierId = (createModifierRes as any)?.modifier?.id || (createModifierRes as any)?.id;
									UI.notification.success("Option set added")
								} else {
									const patchData: any = { ...values };
									if (optionsToUpdate.length > 0) {
										patchData.options = optionsToUpdate;
									}
                  await store.api.menu_partial_update_modifier({
                    restaurant_id: restaurant._id,
                    modifier_id: optionSetsV2[existing].id,
                    data: patchData,
                  })
                  const initialOptions = (this.props.initialValues as any)?.options || [];
                  const currentOptions = values.options || [];
                  const deleteOptionsPromises = [];
                  for (const initialOption of initialOptions) {
                    if (initialOption.id && !currentOptions.find((o: any) => o.id === initialOption.id)) {
                      deleteOptionsPromises.push(store.api.menu_delete_modifier_option({
                        restaurant_id: restaurant._id,
                        modifier_id: optionSetsV2[existing].id,
                        option_id: initialOption.id
                      }))
                    }
                  }
                  await Promise.all(deleteOptionsPromises);
                  if (optionsToUpdate.length > 0) {
                    await store.api.menu_create_modifier_option({
                      restaurant_id: restaurant._id,
                      modifier_id: optionSetsV2[existing].id,
                      data: { options: optionsToUpdate },
                    })
                  }
                  UI.notification.success("Option set updated")
                }
                // @ts-ignore
                const modifierId = values?.id ?? createdModifierId ?? optionSetsV2[existing]?.id;
                if (!modifierId) return;
                const listItems = (restaurant.menus_v2 || []).flatMap((m: any) => m.items || []);
                const itemUpdatePayload = (item: any, modifiers: string[]) => ({
                  menu_id: item.menu_id,
                  category_id: item.category_id,
                  id: item.id,
                  modifiers: modifiers,
                });
                let itemsToUpdate: any[] = [];
                for (const item of listItems) {
                  const modifiers = item.modifiers || [];
                  const hasModifier = modifiers.includes(modifierId)
                  const shouldHaveModifier = add_to.includes(item.id);
                  if (hasModifier && !shouldHaveModifier) {
                    itemsToUpdate.push(itemUpdatePayload(item, modifiers.filter((m: string) => m !== modifierId)));
                  } else if (!hasModifier && shouldHaveModifier) {
                    itemsToUpdate.push(itemUpdatePayload(item, [...modifiers, modifierId]));
                  }
                }

                if (itemsToUpdate.length) {
                  await store.api.menu_partial_update_batch_items({
                    restaurant_id: restaurant._id,
                    data: { items: itemsToUpdate }
                  })
                }
							} catch (e) {
								UI.notification.error(e.error)
							}

							store.setActiveMobileMenu(
								store.activeMobileMenu.referrer.pop()!,
								Array.from(new Set(store.activeMobileMenu.referrer))
							)
						}
						: undefined
					}
					validators={{
						name: (values) => {
							if (!values.name)
								return { name: "This field is required" };
						},
					}}
					initialValues={initialValues}
					onSuccess={() => {
						store.setActiveMobileMenu(
							store.activeMobileMenu.referrer.pop()!,
							Array.from(new Set(store.activeMobileMenu.referrer))
						)
						close
					}}
					onSuccessMessage={type === "edit" ? "Option set edited" : "Option set created"}
				>
					{({ form, error, getFieldError }) => {
						const { isSubmitting, setFieldValue, values } = form;
						runOnceNotification(error)
						console.log('formValues', toJS(values))
						const nameValue = values.name;
						// @ts-ignore
						const displayNameValue = values._internal ? values._internal.display_name : ""

						return (
							<div style={{ paddingBottom: 83 }}>
								<MenuPresenceBar entityId={presenceEntityId(this.props.initialValues)} />
								{tab === "0" && (
									<SettingsFormGroup>

										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Option Set Type</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											{store.isNewMenuSchema ?
												<FastField
													name="type"
													render={({ field }: any) => (

														<TabGroup className='menus' style={{ overflow: 'unset', paddingLeft: 0 }}>
															<TabItem
																//@ts-ignore
																active={field.value === 'standard'}
																onClick={() => { setFieldValue("type", 'standard') }}
															>
																Standard
															</TabItem>
															<TabItem
																//@ts-ignore
																active={field.value === 'pizza'}
																onClick={() => { setFieldValue("type", 'pizza') }}
															>
																Pizza
															</TabItem>
														</TabGroup>
													)}
												/>
												: <FastField
													name="using_points"
													render={({ field }: any) => (

														<TabGroup className='menus' style={{ overflow: 'unset', paddingLeft: 0 }}>
															<TabItem
																//@ts-ignore
																active={!field.value}
																onClick={() => { this.setState({ using_points: false }); setFieldValue("using_points", false) }}
															>
																Standard
															</TabItem>
															<TabItem
																//@ts-ignore
																active={!!field.value}
																onClick={() => { this.setState({ using_points: true }); setFieldValue("using_points", true) }}
															>
																Pizza
															</TabItem>
														</TabGroup>
													)}
												/>}
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="name"
													render={({ field }: any) => (
														<input
															type="text"
															{...field}
															value={nameValue}
															required
														/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Display Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="_internal.display_name"
													render={({ field }: any) => (
														<input
															type="text"
															{...field}
															value={displayNameValue}
														/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsSwitchContainer>
											<SettingsFormLabelLeftContainer>
												Inc. Price in Free Quantity Promos
											</SettingsFormLabelLeftContainer>
											<FastField
												name="_internal.inc_price_free_qty_promo"
												render={({ field }: any) => (
													<Switch
														id="inc_price_free_qty_promo"
														checked={field.value || false}
														onChange={(e) => setFieldValue("_internal.inc_price_free_qty_promo", e.target.checked)} />
												)}
											/>
										</SettingsSwitchContainer>
										{
											!!restaurant.abacus?.abacus_open_items &&

											<SettingsSwitchContainer>
												<SettingsFormLabelLeftContainer>
													Abacus - Disable Printing of Option Set Name
												</SettingsFormLabelLeftContainer>
												<FastField
													name="_internal.abacus_hide_option_set_nam"
													render={({ field }: any) => (
														<Switch
															id="abacus_hide_option_set_name"
															checked={field.value === undefined ? true : field.value}
															onChange={(e) => setFieldValue("_internal.abacus_hide_option_set_nam", e.target.checked)} />
													)}
												/>
											</SettingsSwitchContainer>
										}

										{
											<SettingsSwitchContainer>
												<SettingsFormLabelLeftContainer>
													Disable Printing of Option Set Name
												</SettingsFormLabelLeftContainer>
												<FastField
													name="_internal.print_hide_option_set_name"
													render={({ field }: any) => (
														<Switch
															id="print_hide_option_set_name"
															checked={field.value === undefined ? false : field.value}
															onChange={(e) => setFieldValue("_internal.print_hide_option_set_name", e.target.checked)} />
													)}
												/>
											</SettingsSwitchContainer>
										}

									</SettingsFormGroup>
								)}

								{tab === "1" && (
									<ModalContent style={{ paddingTop: '20px' }}>
										<FormGroup
											error={getFieldError(form, "options")}>
											<FieldOptionSetOptions
												//@ts-ignore
												values={values}
												setFieldValue={setFieldValue}
												option_sets={
													restaurant.option_sets_v2 && restaurant.option_sets_v2.length > 0
														? (restaurant.option_sets_v2 as unknown as T.Schema.Restaurant.Menu.RestaurantOptionSet[])
														: restaurant.option_sets
												}
												defaultEnabled={form.values.conditions && form.values.conditions.required && !form.values.conditions.multi_select}
												restaurantStock={this.state.restaurantStock}
												setRestaurantStock={this.setRestaurantStock}
												isModernVersion
                        isFromMenuV2={true}
											/>
										</FormGroup>
									</ModalContent>
								)}

								{tab === "2" && (
									<div style={{ padding: 16 }}>
										<SettingsFormGroup>
											<SettingsSwitchContainer>
												<SettingsFormLabelLeftContainer>
													Required
												</SettingsFormLabelLeftContainer>
												<FastField
													name="conditions.required"
													render={({ field }: any) => (
														<Switch
															id="conditions.required"
															checked={field.value}
															onChange={(e) => {
																if (!e.target.checked) {
																	setFieldValue("options", form.values.options.map((option) => ({
																		//@ts-ignore
																		...option,
																		quantity: 0,
																	})));
																}
																setFieldValue("conditions.required", e.target.checked);
															}} />
													)}
												/>
											</SettingsSwitchContainer>
											{!using_points && (

												<SettingsSwitchContainer>
													<SettingsFormLabelLeftContainer>
														Select Multiple
													</SettingsFormLabelLeftContainer>
													<FastField
														name="conditions.multi_select"
														render={({ field }: any) => (
															<Switch
																id="conditions.multi_select"
																checked={field.value}
																onChange={(e) => setFieldValue("conditions.multi_select", e.target.checked)} />
														)}
													/>
												</SettingsSwitchContainer>

											)
											}
											{!using_points && (

												<SettingsSwitchContainer>
													<SettingsFormLabelLeftContainer>
														Enable Option Quantity
													</SettingsFormLabelLeftContainer>
													<FastField
														name="conditions.quantity_select"
														render={({ field }: any) => (
															<Switch
																id="conditions.quantity_select"
																checked={field.value}
																onChange={(e) => setFieldValue("conditions.quantity_select", e.target.checked)} />
														)}
													/>
												</SettingsSwitchContainer>
											)}

											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>Min Options Required</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
														<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												<SettingsFormInputContainer>
													<FastField
														name="conditions.min_options"
														render={({ field }: any) => (
															<input
																type="number" step={1} min={0} {...field}
															/>
														)} />
												</SettingsFormInputContainer>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>Max Options Allowed</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
														<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												<SettingsFormInputContainer>
													<FastField
														name="conditions.max_options"
														render={({ field }: any) => (
															<input
																type="number" step={1} min={0} {...field}
															/>
														)} />
												</SettingsFormInputContainer>
											</SettingsFormGroupInput>

											{!using_points && (
												<SettingsFormGroupInput>
													<SettingsFormLabelContainer>
														<SettingsFormLabelLeftContainer>Free Quantity</SettingsFormLabelLeftContainer>
														<SettingsFormLabelRightContainer>
															<IconHelp />
														</SettingsFormLabelRightContainer>
													</SettingsFormLabelContainer>
													<SettingsFormInputContainer>
														<FastField
															name="conditions.free_amount"
															render={({ field }: any) => (
																<input
																	type="number" step={1} min={0} {...field}
																/>
															)} />
													</SettingsFormInputContainer>
												</SettingsFormGroupInput>
											)
											}
										</SettingsFormGroup>
									</div>
								)}

								{tab === "3" && (
									<div style={{ padding: 16 }}>
										<SettingsFormGroupInput style={{ gap: 16 }}>

											<EligibleItemsContainer className='menus-v2'>
												<FormTreeSelect
													id={`add-to-dishes`}
													selected={add_to}
													nodes={store.isNewMenuSchema ? (RestaurantUtils.menu as any).getTreeFilterV2(restaurant) : RestaurantUtils.menu.getTreeFilter(restaurant, () => true)}
													onChange={(add_to_dishes) => {
														this.setState({ add_to: add_to_dishes });
													}}
												/>
											</EligibleItemsContainer>

										</SettingsFormGroupInput>
									</div>
								)}

								{tab === "4" && (
									<ModalContent>
										{type !== "edit" && (
											<FastField
												name="using_points"
												render={({ field }: any) => (
													<FormGroup title="Option Set Type"
														help="A Pizza option set allows the use of a point system to set limits to item add-ons. More info in (LINK HERE).">
														<ButtonGroup
															width={100}
															size="sm"
															selected={field.value === true ? 1 : 0}
															options={[
																{ name: "Standard", value: 0 },
																{ name: "Pizza", value: 1 },
															]}
															onSelect={({ value }) => {
																setFieldValue("using_points", value === 1);
																this.setState({ using_points: value === 1 });
															}
															}
														/>
													</FormGroup>
												)}
											/>
										)}
										<FastField name="integrations.pushpos.category_id">
											{({ field, form }: any) => (
												<FormGroup
													title="POS Category Id"
													help="A unique id for your category"
													error={getFieldError(form, "integrations.pushpos.category_id")}>
													<Input type="number" {...field} value={field.value ?? ""} required={false} onChange={posNumberonChange(field, form)} />
												</FormGroup>
											)}
										</FastField>
									</ModalContent>
								)}

								<SettingsActionButtonContainer>
									<SettingsActionButtonWrapper style={{ left: 0 }}>
										<button type="button"
											className="default btn-cancel"
											onClick={() => {
												store.setActiveMobileMenu(
													store.activeMobileMenu.referrer.pop()!,
													Array.from(new Set(store.activeMobileMenu.referrer))
												);
											}}>
											Cancel
										</button>
										<button type="submit" disabled={isSubmitting}>
											{isSubmitting && <RotateLoader size={2} color="white" />}
											{!isSubmitting && "Save"}
										</button>
									</SettingsActionButtonWrapper>
								</SettingsActionButtonContainer>

							</div>
						);
					}}
				</RestaurantForm>
			</div>
		);

	}

}
